import React from 'react';
import styles from './input.module.scss';

const Input = (props) => {
  const { label, id, value } = props;
  return (
    <label className={styles.inputContainer}>
      <span
        className={`${styles.label} ${value ? styles.active : styles.not_active}`}
        htmlFor={id}
      >
        {label}
      </span>

      <input
        className={`${styles.input} ${!value ? styles.active : ''}`}
        {...props}
      />
    </label>
  );
};

export default Input;
